<template>
  <div>

    <Form :model="form" :rules="ruleForm" label-position="top" ref="form">
      <Row :gutter="32">
        <Col span="12">
          <FormItem label="Address 1" prop="addressLine1">
            <Input placeholder="Enter your Address" v-model="form.addressLine1"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="Address 2" prop="addressLine2">
            <Input placeholder="Enter your Address" v-model="form.addressLine2"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem label="City" prop="city">
            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: '%' + form.city + '%'}">
              <template slot-scope="{ result: { loading, error, data } }">
                <div v-if="loading"> Loading...</div>
                <div v-else-if="error"> Error Occurred. {{error}}</div>
                <div v-else-if="data">
                  <AutoComplete placeholder="Search City" v-model="form.city">
                    <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data.city">
                      <div  class="ivu-select-item-div" @click="form.state=cityObj.state;selectedCityId=cityObj.id">{{cityObj.city}}</div>
                    </Option>
                  </AutoComplete>
                </div>
                <div v-else>There are no City Available yet.</div>
              </template>
            </ApolloQuery>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="State" prop="state">
            <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter: '%' + form.state + '%'}">
              <template slot-scope="{ result: { loading, error, data } }">
                <div v-if="loading"> Loading...</div>
                <div v-else-if="error"> Error Occurred. {{error}}</div>
                <div v-else-if="data">
                  <AutoComplete placeholder="Search State" v-model="form.state">
                    <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data.territories">
                      <div  class="ivu-select-item-div">{{stateObj.state}}</div>
                    </Option>
                  </AutoComplete>
                </div>
                <div v-else>There are no State Available yet.</div>
              </template>
            </ApolloQuery>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem label="Area" prop="area">
            <Select v-model="form.area" filterable>
              <Option v-for="(area,index) in areaArr" :value="area.area" :label="area.area" :key="index">
                <div  class="ivu-select-item-div">{{area.area}}</div>
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="PIN Code" prop="pincode">
            <Input type="number" placeholder="Enter your PIN" v-model="form.pincode"></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>

  </div>
</template>

<script>
import ValidationRules from "../../Constants/ValidationRules";
import {GET_AREAS_BY_CITY} from "../../graphql/queries/area";
import {GET_CITY_BY_NAME, SEARCH_CITY2, SEARCH_STATE} from "../../graphql/queries/territories";

export default {
    name: "AddressForm",
    apollo: {
      area: {
        query: GET_AREAS_BY_CITY,
        variables() { return { cityId: this.selectedCityId }},
        result({data}) { this.areaArr = data.area }
      }
    },
    data(){
      return{
        query_SEARCH_CITY: SEARCH_CITY2,
        query_SEARCH_STATE: SEARCH_STATE,
        form: {
          addressLine1: '',
          addressLine2: '',
          area: '',
          pincode: null,
          city: '',
          state: ''
        },
        ruleForm: {
          addressLine1: ValidationRules.add2, area: ValidationRules.selectField,
          city: ValidationRules.selectField, state: ValidationRules.selectField
        },
        selectedCityId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
        areaArr: [],
      }
    },
  methods:{
      modifyAddressAndSetForm(address){
          let {add1:addressLine1, add2:addressLine2, area, city, state, pincode} = address
          this.form = {addressLine1, addressLine2, area, city, state, pincode}
          this.getCityByName(city)
      },
      setForm(address){
          Object.copyExistingKeys(this.form, address)
          this.getCityByName(address.city)
      },
      getForm(){
        return {...this.form, pincode: this.form.pincode?.toString()}
      },
      async getCityByName(name){                               //To Fetch areas from cityId
        let response = await this.$apollo.query({
          query: GET_CITY_BY_NAME,
          variables: { name: name},
          fetchPolicy: 'network-only',
        })
        if(response.data.city.length) this.selectedCityId = response.data.city[0].id
      },
      validateForm(){                                     //return promise for parent component
        return this.$refs['form'].validate()
      },
      resetForm(){
        this.$refs['form'].resetFields()
      }
  }
}
</script>

<style scoped>
  /deep/ .ivu-select-item{
    padding: 0px 0px;
  }
  /deep/ .ivu-select-item-div{
    width: 100%;
    padding: 7px 16px;
  }
  /deep/ .ivu-auto-complete.ivu-select-dropdown{
    max-height: 200px !important;
  }
</style>
